import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IGetBookingsCommonResponse, TGetBookingResponse } from "libraries/service/resources/booking/interfaces/IGetBookings";
import { Yii } from "libraries/interfaces/Yii";
import { CardComponent } from 'libraries/ui_card/card.component';
import {
    IconDefinition,
    faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

interface ILabels {
    cardTitle: string;
}

@Component({
    selector: 'booking-quality-control',
    template: `
        <card #cardContainer [isCollapsible]="true">
            <div class="card-header-content">
                <div class="title" (click)="menuToggleCard()">
                    <fa-icon [icon]="icon" class="{{cssClass}}"></fa-icon>
                    {{ labels.cardTitle }}
                </div>
            </div>
            <div class="card-body-content">
                <booking-quality-control-data [booking]="booking"></booking-quality-control-data>
            </div>
        </card>
    `,
    styles: [`
        .warning {
            color: #8a6d3b;
        }
        
        .card-body-content{
            padding: 0;
        }
    `
    ]
})
export class BookingQualityControlComponent {

    @ViewChild('cardContainer')
    public cardContainer: CardComponent;

    @Input()
    public booking: IGetBookingsCommonResponse;

    @Output()
    public readonly onCardTitleClick: EventEmitter<string> = new EventEmitter();

    public labels: ILabels = {
        cardTitle: Yii.t('wui-shared-js', 'Contrôle qualité'),
    };

    public name: string = 'bookingQualityControl';
    public icon: IconDefinition = faExclamationTriangle;
    public cssClass: string = "warning";

    public menuToggleCard(): void {
        this.onCardTitleClick.emit(this.name);
    }

}
